import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Search, BadgeDollarSign, ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import heroAvif from "@/assets/hero-beach.avif.asset.json";
import PropertyGrid from "@/components/PropertyGrid";
import FeaturesSection from "@/components/FeaturesSection";
import Footer from "@/components/Footer";
import StickyBookNow from "@/components/StickyBookNow";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Amplify Vacations | Luxury Panama City Beach Rentals</title>
        <meta name="description" content="Book coastal luxury vacation rentals in Panama City Beach, FL. Private pools, steps from the beach, family-friendly homes by Amplify Vacations." />
        <link rel="canonical" href="https://amplifyvacations.com/" />
        <meta property="og:title" content="Amplify Vacations | Luxury Panama City Beach Rentals" />
        <meta property="og:description" content="Book coastal luxury vacation rentals in Panama City Beach, FL. Private pools, steps from the beach, family-friendly homes by Amplify Vacations." />
        <meta property="og:url" content="https://amplifyvacations.com/" />
        <link rel="preload" as="image" type="image/avif" href={heroAvif.url} fetchPriority="high" />
      </Helmet>
      <Navbar />
      <HeroSection />
      <div aria-hidden className="h-px bg-gradient-to-r from-transparent via-border to-transparent" />
      <PropertyGrid />
      <div aria-hidden className="h-px bg-gradient-to-r from-transparent via-border to-transparent" />
      <FeaturesSection />

      {/* Direct-rate finder cross-link — homepage internal link to /concierge */}
      <section className="py-16 md:py-24 bg-background">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl mx-auto rounded-3xl border border-accent/40 bg-accent/10 p-8 md:p-12 text-center">
            <p className="inline-flex items-center justify-center gap-2 font-body text-xs font-semibold uppercase tracking-wide text-accent mb-4">
              <BadgeDollarSign className="h-4 w-4" aria-hidden="true" />
              Amplify Concierge
            </p>
            <h2 className="font-display text-3xl md:text-4xl font-semibold text-foreground mb-4">
              Found the same home on Airbnb or Vrbo? Find the direct rate worldwide.
            </h2>
            <p className="font-body text-muted-foreground leading-relaxed mb-8 max-w-xl mx-auto">
              Paste any listing URL and your dates. We'll check whether that exact property is bookable direct anywhere in the world — usually 14–20% less once the guest service fee is gone.
            </p>
            <Link
              to="/concierge"
              className="inline-flex items-center gap-2 rounded-full bg-accent px-6 py-3 font-body font-semibold text-accent-foreground transition-colors hover:bg-accent/90"
            >
              <Search className="h-4 w-4" aria-hidden="true" />
              Find direct rates worldwide
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <StickyBookNow />
    </div>
  );
};

export default Index;
